export default "__VITE_ASSET__BTwhw0D5__"